export default __webpack_public_path__ + "static/media/runner.c0a49191.png";